import type { EmailMacro } from '../../services/emailTemplatesApi';

type MessageMacroChipsProps = {
  macros: Array<Pick<EmailMacro, 'key' | 'description'>>;
  disabled?: boolean;
  onInsert: (token: string) => void;
};

export function MessageMacroChips({
  macros,
  disabled = false,
  onInsert,
}: MessageMacroChipsProps) {
  if (macros.length === 0) {
    return null;
  }

  return (
    <div className="erp-form-grid-full">
      <p className="mb-1 text-xs font-medium text-secondary-600">Macros</p>
      <div className="flex flex-wrap gap-1.5">
        {macros.map((macro) => {
          const token = `{{${macro.key}}}`;
          return (
            <button
              key={macro.key}
              type="button"
              className="rounded-full border border-secondary-300 bg-white px-2.5 py-1 text-xs text-secondary-800 hover:border-primary-300 hover:bg-primary-50 disabled:opacity-50"
              title={`Inserir ${token}`}
              disabled={disabled}
              onClick={() => onInsert(token)}
            >
              {macro.description}
            </button>
          );
        })}
      </div>
      <p className="erp-hint mt-1">
        Clique para inserir no campo em foco (assunto ou mensagem).
      </p>
    </div>
  );
}
